import { useState } from 'react';
import { X } from 'lucide-react';

function PillInput({ value, onChange, placeholder }) {
  const [draft, setDraft] = useState('');

  const commit = (text) => {
    const trimmed = text.trim();
    if (!trimmed || value.includes(trimmed)) return;
    onChange([...value, trimmed]);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      commit(draft);
      setDraft('');
    } else if (e.key === 'Tab' && draft.trim()) {
      commit(draft);
      setDraft('');
    } else if (e.key === 'Backspace' && !draft && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const handleBlur = () => {
    commit(draft);
    setDraft('');
  };

  const removeAt = (index) => onChange(value.filter((_, i) => i !== index));

  return (
    <div className="pill-input">
      {value.map((item, i) => (
        <span key={item} className="pill-input-tag">
          {item}
          <button type="button" className="pill-input-remove" onClick={() => removeAt(i)}>
            <X size={12} />
          </button>
        </span>
      ))}
      <input
        className="pill-input-field"
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={value.length === 0 ? placeholder : ''}
      />
    </div>
  );
}

export default PillInput;
